import { render, staticRenderFns } from "./item.image.vue?vue&type=template&id=71e384d4&"
import script from "./item.image.vue?vue&type=script&lang=js&"
export * from "./item.image.vue?vue&type=script&lang=js&"
import style0 from "./item.image.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports